/**
 * „Blender ohne Einzelfreigabe“ — die Wörter zwischen Server und Seite. (12.10.2026, Postfach Nr. 27; „Immer“ seit 15.10.2026)
 *
 * Martin schaltet es in den Einstellungen ein — für eine Stunde oder „Immer (bis ich ausschalte)“; danach fragt Blender nicht mehr vor
 * jeder Änderung („Darf ich in Blender arbeiten?“). Rückgängig, die gestaffelten Sicherungen und die Sperre nach gelesenem Fremdtext
 * bleiben. Der Server entscheidet (server/sitzungs-ja.ts, server/blender-freigabe-route.ts); die Seite zeigt nur den Stand und die Knöpfe.
 */
export const BLENDER_FREIGABE_PFAD = "/api/blender-freigabe";
/** Dieselbe Kopfzeile wie beim Update-Knopf (server/update-starten-route.ts), mit eigenem Wert. */
export const BLENDER_FREIGABE_KOPF_WERT = "blender-freigabe";
export const BLENDER_FREIGABE_MINUTEN = 60;

/** `einschalten` = eine Stunde (Name von 12.10. bleibt, damit eine ältere Seite weiter funktioniert), `dauer` = Immer, `ausschalten` = alles zurück. */
export type BlenderFreigabeAktion = "einschalten" | "dauer" | "ausschalten";

export interface BlenderFreigabeStand {
  ok: boolean;
  /** Darf dieses Konto den Schalter bedienen (Betreiberkonto)? */
  erlaubt: boolean;
  /** Läuft Blender gerade ohne Einzelfrage (Fenster, 4-Stunden-Ja oder Immer)? */
  an: boolean;
  /** Sekunden, die noch bleiben (0 = aus oder Immer). */
  rest_s: number;
  /** „Immer (bis ich ausschalte)“ ist eingeschaltet. Fehlt bei einem älteren Server = nein. */
  dauer?: boolean;
  /** Überlebt der Stand einen Neustart des Servers (Ablage an)? Fehlt = ja (ältere Server sagten es nicht). */
  ueber_neustart?: boolean;
}

export const istAktion = (v: unknown): v is BlenderFreigabeAktion => v === "einschalten" || v === "dauer" || v === "ausschalten";

/** „noch 54 Min“ / „noch 45 s“ — der Rest in einfachen Worten. */
export function restText(restS: number): string {
  if (!(restS > 0)) return "";
  return restS >= 60 ? `noch ${Math.ceil(restS / 60)} Min` : `noch ${Math.ceil(restS)} s`;
}

export function standSatz(s: Pick<BlenderFreigabeStand, "an" | "rest_s" | "dauer" | "ueber_neustart">): string {
  if (s.dauer) {
    const neustart = s.ueber_neustart === false ? " Achtung: gilt nur bis zum nächsten Neustart des Servers." : "";
    return `Immer an — Blender fragt nicht mehr, außer nach gelesenem Fremdtext.${neustart}`;
  }
  return s.an && s.rest_s > 0 ? `An — ${restText(s.rest_s)}. Danach fragt Blender wieder.` : "Aus — Blender fragt vor jeder Änderung.";
}

export const NACH_FREMDTEXT_HINWEIS =
  "Rückgängig und die Sicherungen bleiben. Hat Vespera fremden Text gelesen (Webseite, Mail, Anhang), fragt Blender trotzdem nach.";
